// @flow
import type { Action } from 'app/common/redux/types';

export type State = {
  invite: Object,
  loadedState: 'Unloaded' | 'Loaded' | 'Cleared',
};

export const INVITE_OBJECT_STATE = Object.freeze({
  loaded: 'Loaded',
  unloaded: 'Unloaded',
  cleared: 'Cleared',
});

const initialState = {
  invite: {},
  loadedState: INVITE_OBJECT_STATE.unloaded,
};

const inviteObject = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'UPDATE_INVITER_DATA':
      return { invite: action.payload, loadedState: INVITE_OBJECT_STATE.loaded };
    case 'CLEAR_INVITER_DATA':
      return { invite: {}, loadedState: INVITE_OBJECT_STATE.cleared };
    default:
      return state;
  }
};

export default inviteObject;
